import * as React from "react";
import { getDisplayName } from "@grandvisionhq/utils";
import { useBloomreachPageable } from "../../hooks/hooks/use-bloomreach-pageable.js";
function withBloomreachPageable(Component) {
  const displayName = getDisplayName(Component);
  const WithBloomreachPageable = (props) => {
    const { refs, data } = useBloomreachPageable(props);
    if (!data.content.items?.length) {
      console.warn(
        `Trying to render Bloomreach pageable component: ${displayName}, but found no content documents. Refs: ${refs}`
      );
      return /* @__PURE__ */ React.createElement(Component, { ...props, content: { items: [] } });
    }
    return /* @__PURE__ */ React.createElement(Component, { ...data, ...props });
  };
  WithBloomreachPageable.displayName = `WithBloomreachPageable(${displayName})`;
  return WithBloomreachPageable;
}
export {
  withBloomreachPageable
};
//# sourceMappingURL=with-bloomreach-pageable.js.map
